import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { Alert } from '@material-ui/lab';
import React, { useState } from 'react';
import WindsorApi from '../../api/WindsorApi';
import LoadingButton from '../../common/LoadingButton';
import FileUploadForm from './FileUploadForm';
import FileUtils from './FileUtils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    alert: {
      marginBottom: 24
    },
    dialogContent: { 
      width: 400 
    },
    nameTextField: { 
      marginBottom: 24 
    }
  })
);

interface Props {
  familyId: string;
  test: any;
  onClose: (test?: any) => void;
}

const windsorApi = new WindsorApi();

function EditTestDialog(props: Props) {
  const { familyId, test, onClose } = props;
  const classes = useStyles({});
  const [file, setFile] = useState(null);
  const [showFormErrors, setShowFormErrors] = useState(false);
  const [serverError, setServerError] = useState(null);
  const [updateInProgress, setUpdateInProgress] = useState(false);

  const onFileChange = (file) => {
    setFile(file);
  };

  const onCreateTest = async () => {
    setServerError(null);
    if (!file) {
      setShowFormErrors(true);
    } else {
      setUpdateInProgress(true);
      const fileBytes = await new FileUtils().readFileBytes(file);

      windsorApi.updateTest(familyId, test.name, fileBytes).then(res => {
        onClose(res);
      }).catch(error => {
        setUpdateInProgress(false);
        if (error.status === 400) {
          setServerError(error.data.errorMessage);
        } else {
          setServerError('Unknown error occurred, please try your request again...')
        }
      });
    }
  };

  return (<Dialog
    open={true}
    onClose={() => onClose()}
    disableBackdropClick={updateInProgress}
    aria-labelledby="update-test-dialog-title"
    aria-describedby="update-test-dialog-description"
  >
    <DialogTitle id="update-test-dialog-title">Update Windsor Test</DialogTitle>
    <DialogContent className={classes.dialogContent}>
      {serverError && <Alert severity="error" className={classes.alert}>
        <Typography>{serverError}</Typography>
      </Alert>}
      <TextField
        fullWidth
        required
        className={classes.nameTextField}
        value={test.name}
        label="Test Name"
        disabled
        InputLabelProps={{
          shrink: true
        }}
      />
      <FileUploadForm file={file} showFormErrors={showFormErrors} onFileChange={onFileChange} />
    </DialogContent>
    <DialogActions>
      <Button disabled={updateInProgress} onClick={() => onClose()} color="primary">
        Cancel
      </Button>
      <LoadingButton
        color="primary"
        variant="text"
        loading={updateInProgress}
        onClick={onCreateTest}>
        Update
      </LoadingButton>
    </DialogActions>
  </Dialog>
  );
};

export default EditTestDialog;
